import React from 'react';
import type { FC } from 'react';

import { toast } from 'sonner';

import { Button } from '@shared/components/bootstrap';
import { useToggle } from '@shared/hooks/use_toggle';

import { Permission } from '@admin/components/helpers/permission';
import { BILLING } from '@admin/libraries/access_control_catalog.generated';

import { BillingSourceDialog } from './billing_source_dialog';

export const BillingSourceDialogButton: FC<{
  accountID: string;
}> = ({ accountID }) => {
  const { visible, onToggle } = useToggle();
  return (
    <Permission resource={BILLING.resource} action={BILLING.actions.update} denied={null}>
      <Button type="button" kind="primary" onClick={onToggle}>
        Add Credit / Debit Card
      </Button>

      {visible && (
        <BillingSourceDialog
          accountID={accountID}
          onClose={() => {
            onToggle();
          }}
          onSave={(source) => {
            onToggle();

            toast.info(`····${source.number} is now attached to this account.`);
          }}
        />
      )}
    </Permission>
  );
};
